import { render, staticRenderFns } from "./hotSaleListReport.vue?vue&type=template&id=486e766e&scoped=true&"
import script from "./hotSaleListReport.vue?vue&type=script&lang=js&"
export * from "./hotSaleListReport.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleListReport.vue?vue&type=style&index=0&id=486e766e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e766e",
  null
  
)

export default component.exports